// 각 경로별 페이지 타이틀 정의
export const PAGE_TITLES = {
  DEFAULT: '전주현암교회',
  MAIN: 'Main Page',
  SIGN_IN: '전주현암교회-로그인',
  SIGN_UP: '전주현암교회-회원가입',
  JRAUM: '전주현암교회 J-raum',
  MANAGER: '제이라움_관리자',
  ORDER: '제이라움_주문내역',
  POINT: '제이라움_포인트_관리',
  USER: '제이라움_회원_관리',
  MENU: '제이라움_메뉴_관리',
} as const; 